import {
  put, all, call, select, takeLatest,
} from 'redux-saga/effects';

import { delay } from 'redux-saga';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { exception } from 'circe/logger';
import { fetch, fetched } from './actions';
import { fetch as fetchApi } from './api';
import shipmentsEscalationSaga from './shipmentEscalation/saga';
import reassignmentSaga from './reassignment/saga';

const doFetch = function* ({ payload }) {
  try {
    const { filters } = payload;

    const state = yield select();

    const headers = yield call(getCurrentAuthHeader, state);

    const response = yield call(fetchApi, filters, headers);

    yield delay(2500);

    yield put(fetched(response));
  } catch (e) {
    exception(e);
  }
};

export default function* () {
  yield all([takeLatest(fetch().type, doFetch), shipmentsEscalationSaga(), reassignmentSaga()]);
}
